import React from "react";

interface FileIconProps extends React.SVGProps<SVGSVGElement> {}

const FileIcon: React.FC<FileIconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
      fill="currentColor"
    />
    <path d="M14 2V8H20" fill="currentColor" opacity="0.5" />
  </svg>
);

export { FileIcon };
export default FileIcon;
